import { render, staticRenderFns } from "./CustomerBiodata.vue?vue&type=template&id=5bbddceb"
import script from "./CustomerBiodata.vue?vue&type=script&lang=js"
export * from "./CustomerBiodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports